import React, { useEffect, useState } from 'react';
import { PillsInput, Pill, Combobox, CheckIcon, Group, useCombobox, Box } from '@mantine/core';

type SearchablePillInputProps = {
  items: string[]
  selected?: string[] | null
  onSelect?: (newValues: string[], selectedValue: string) => void
  onRemove?: (newValues: string[], selectedValue: string) => void
  placeholder?: string
  nothingFoundMessage?: string
  w?: string | number
}

export const SearchablePillInput = (props: SearchablePillInputProps) => {
  const {
    items,
    selected,
    onSelect = () => undefined,
    onRemove = () => undefined,
    placeholder,
    nothingFoundMessage = 'Nothing found...',
    w = '100%'
  } = props

  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
    onDropdownOpen: () => combobox.updateSelectedOptionIndex('active'),
  });

  const [search, setSearch] = useState('');
  const [value, setValue] = useState<string[]>(selected || []);

  const handleValueSelect = (val: string) => {
    const newValues = value.includes(val) ? value.filter((v) => v !== val) : [...value, val]
    onSelect(newValues, val)
    setValue(newValues);
  }

  const handleValueRemove = (val: string) => {
    const newValues = value.filter(v => v !== val)
    onRemove(newValues, val)
    setValue(newValues);
  }

  const values = value.map((item) => (
    <Pill 
      style={{ fontSize: 14, height: 30, paddingTop: 5, paddingBottom: 5 }} 
      key={item} withRemoveButton 
      onRemove={() => handleValueRemove(item)}
    >
      {item}
    </Pill>
  ));

  const options = items
    .filter((item) => item.toLowerCase().includes(search.trim().toLowerCase()))
    .map((item) => (
      <Combobox.Option value={item} key={item} active={value.includes(item)}>
        <Group gap="sm">
          {value.includes(item) ? <CheckIcon size={12} /> : null}
          <span>{item}</span>
        </Group>
      </Combobox.Option>
    ));

  useEffect(() => {
    setValue(selected || [])

  }, [selected])

  return (
    <Box w={w}>
      <Combobox size='lg' store={combobox} onOptionSubmit={handleValueSelect}>
        <Combobox.DropdownTarget>
          <PillsInput size='lg' onClick={() => combobox.openDropdown()}>
            <Pill.Group>
              {values}
              <Combobox.EventsTarget>
                <PillsInput.Field
                  onFocus={() => combobox.openDropdown()}
                  onBlur={() => combobox.closeDropdown()}
                  value={search}
                  placeholder={placeholder}
                  onChange={(event) => {
                    combobox.updateSelectedOptionIndex();
                    setSearch(event.currentTarget.value);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === 'Backspace' && search.length === 0) {
                      event.preventDefault();
                      handleValueRemove(value[value.length - 1]);
                    }
                  }}
                />
              </Combobox.EventsTarget>
            </Pill.Group>
          </PillsInput>
        </Combobox.DropdownTarget>

        <Combobox.Dropdown>
          <Combobox.Options>
            <Box mah={500} style={{ overflow: 'scroll' }}>
              {options.length > 0 ? options : <Combobox.Empty>{nothingFoundMessage}</Combobox.Empty>}
            </Box>
          </Combobox.Options>
        </Combobox.Dropdown>
      </Combobox>
    </Box>
  );
}
